<template>
  <div>
    <!-- <el-button
      type="primary"
      @click="UpdateCompanyIntroduction(null)"
      v-if="hasAuth('sys:sizetext:add')"
      >添加</el-button
    > -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%;"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column label="标题" align="center" prop="title" width="400">
      </el-table-column>
      <el-table-column label="内容" align="center">
        <template slot-scope="scope">
          <div class="" v-html="scope.row.content" style="height: 60px;"></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="icon"
        align="center"
        width="360"
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="UpdateCompanyIntroduction(scope.row)"
            v-if="hasAuth('sys:sizetext:edit')"
            >编辑</el-button
          >
          <el-button
            type="warning"
            plain
            @click="detail(scope.row)"
            v-if="hasAuth('sys:sizetext:detail')"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <UpdateCompanyIntroduction
      ref="updateCompanyIntroduction"
      v-if="UpdateCompanyIntroductionvisible"
      @refreshDataList="getCompanyIntroduction"
    ></UpdateCompanyIntroduction>
    <el-dialog
      :title="obj.title"
      :visible.sync="visible"
      width="60%"
      append-to-body
      :before-close="handlClose"
    >
      <div v-html="obj.content"></div>
    </el-dialog>
  </div>
</template>

<script>
import UpdateCompanyIntroduction from "./UpdateCompanyIntroduction";
export default {
  name: "CompanyIntroduction",
  components: {
    UpdateCompanyIntroduction,
  },
  data() {
    return {
      obj: {},
      visible: false,
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      UpdateCompanyIntroductionvisible: false,
    };
  },
  created() {
    this.getCompanyIntroduction();
  },
  methods: {
    detail(i) {
      this.obj = i;
      this.visible = true;
    },
    handlClose() {
      this.visible = false;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },
    //获取关于我们
    getCompanyIntroduction() {
      this.$axios.get("/admin/agreement/getList").then((res) => {
        this.tableData = res.data;
      });
    },
    UpdateCompanyIntroduction(id) {
      this.UpdateCompanyIntroductionvisible = true;
      this.$nextTick(() => {
        this.$refs.updateCompanyIntroduction.init(id);
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
